exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:'bebas-fallback';size-adjust:75%;src:local(\"Helvetica Neue\")}\n", ""]);

// exports
